import { useTranslation } from 'react-i18next';
import styles from './SkipToContent.module.scss';

/**
 * "דילוג לתוכן הראשי" - WCAG 2.4.1 (רמה A).
 *
 * הקישור מוסתר עד שהוא מקבל מיקוד מהמקלדת. הוא חייב להיות האלמנט הראשון
 * שמקבל מיקוד בעמוד, ולכן מרונדר לפני ה-Router.
 *
 * היעד נפתר בזמן הלחיצה ולא נקבע מראש: חלק מהמסלולים הציבוריים
 * (עמוד תרומה, פתיחת קרן) יושבים מחוץ ל-Layout ואין להם FrameSection,
 * ולכן `#main-content` לא תמיד קיים. במקום קישור שבור, נופלים בהדרגה
 * ל-main, ל-role="main", ולבסוף לשורש האפליקציה.
 */
const SkipToContent = () => {
  const { t } = useTranslation();

  const focusMainContent = (e: React.MouseEvent<HTMLAnchorElement>) => {
    const target =
      document.getElementById('main-content') ??
      document.querySelector<HTMLElement>('main') ??
      document.querySelector<HTMLElement>('[role="main"]') ??
      document.getElementById('root');

    if (!target) return;

    e.preventDefault();
    // ללא tabindex אלמנט שאינו אינטראקטיבי לא יכול לקבל מיקוד תכנותי.
    if (!target.hasAttribute('tabindex')) target.tabIndex = -1;
    target.focus({ preventScroll: false });
    target.scrollIntoView({ block: 'start' });
  };

  return (
    <a href="#main-content" className={styles.skipLink} onClick={focusMainContent}>
      {t('accessibility.skipToContent')}
    </a>
  );
};

export default SkipToContent;
